export default __webpack_public_path__ + "static/media/trail_sword.50a7cb2c.bmp";